"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _socialIconFactory = _interopRequireDefault(require("./socialIconFactory"));
const useClasses = (0, _styles.makeStyles)({
  root: {
    '&:hover, &:focus': {
      color: '#5865f2'
    }
  },
  focus: {
    color: '#5865f2'
  }
}, {
  classNamePrefix: 'TCUIIconDiscord'
});
const Discord = (0, _socialIconFactory.default)(useClasses, ['fab', 'discord'], 'Discord');
var _default = exports.default = Discord;